import Analyses from "api/lib/data/Analyses";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import * as routes from "src/constants/routes";
import { AnalysisForm } from "src/containers/Analyses/AnalysisForm";
import { Base, IBaseProps, IBaseState } from "../Common/Base";

export interface IAnalysesNavProps extends IBaseProps {
  orgId: string;
  history: any;
}

export interface IAnalysesNavState extends IBaseState {
  analyses: any[];
  modal: boolean;
}

export default class AnalysesNav extends Base<
  IAnalysesNavProps,
  IAnalysesNavState
> {
  private static INITIAL_STATE = {
    analyses: [],
    listeners: [],
    modal: false,
  };
  constructor(props: IAnalysesNavProps) {
    super(props);

    this.state = { ...AnalysesNav.INITIAL_STATE };
  }

  public render() {
    const { analyses } = this.state;
    const { authUser, orgId } = this.props;

    return (
      <React.Fragment>
        <Menu.Header>Analyses</Menu.Header>
        <Menu.Menu className="list-menu">
          {/* <Dropdown.Item
                text="Create New"
                onClick={this.handleNewAnalysisClicked}
              />
            <Dropdown.Divider />
            <Input icon="search" iconPosition="left" className="search" /> */}

          {analyses.map((option: any) => (
            <Menu.Item
              as={NavLink}
              activeClassName="active"
              to={routes.ANALYSIS(orgId, option.id)}
              key={option.id}
              name={option.name}
            />
          ))}
        </Menu.Menu>
        <Menu.Menu>
          <Menu.Item
            as={NavLink}
            activeClassName="active"
            to={routes.ANALYSES(orgId)}
            name="Show All"
          />
          <AnalysisForm
            authUser={authUser}
            orgId={orgId}
            trigger={<Menu.Item name="New" />}
          />
        </Menu.Menu>

        {/* Add Channel Modal */}
      </React.Fragment>
    );
  }

  public componentDidMount = () => {
    this.getData();
  };

  public getData = () => {
    const { orgId, authUser } = this.props;
    const analyses = new Analyses(orgId);
    this.getList(analyses, authUser.uid, (data: any[]) => {
      this.setState({ analyses: data });
    });
  };
  // private handleAnalysisClicked = (analysis: any) => {
  //   this.props.history.push(routes.ANALYSIS(this.props.orgId, analysis));
  // };
}



// WEBPACK FOOTER //
// ./src/components/Navigation/AnalysesNav.tsx